export enum ActionType {
    // API
    SUBMIT_FORM,
    FORM_RESPONSE,
    FORM_ERROR,
    WAIVER_TEXT_REQUEST,
    WAIVER_TEXT_RECEIVED,
    WAIVER_TEXT_ERROR,
    DEPOSIT_AMOUNT_REQUEST,
    DEPOSIT_AMOUNT_RECEIVED,
    DEPOSIT_AMOUNT_ERROR,
    EXISTING_DATA_REQUEST,
    EXISTING_DATA_RECEIVED,
    EXISTING_DATA_ERROR,
    SHOW_ALLERGIES_RADIO_REQUEST,
    SHOW_ALLERGIES_RADIO_RECEIVED,
    SHOW_ALLERGIES_ERROR,
    CAMP_OPTIONS_REQUEST,
    CAMP_OPTIONS_RESPONSE,
    // Step Counting
    TO_STEP,
    // Step 1
    SAVE_BASIC_INFORMATION,
    NEW_PARENT,
    SAVE_PARENT,
    REMOVE_PARENT,
    CHANGE_CORRESPONDENCE,
    NEW_SIBLING,
    SAVE_SIBLING,
    REMOVE_SIBLING,
    SAVE_ABOUT_MY_CHILD,
    // Step 2
    SAVE_EMERGENCY_CONTACT,
    SAVE_HEALTHCARE_CONTACT,
    SAVE_INSURANCE_INFORMATION,
    SAVE_PICKUP_AUTHORIZATION,
    SAVE_TRANSPORTATION_PERMISSION,
    // Step 3
    NO_TO_ALL_ALLERGIES,
    SAVE_ALLERGY_LIST,
    SAVE_ALLERGY_EPIPEN,
    SAVE_ALLERGY_LUNCH,
    SAVE_DIETARY_RESTRICTIONS,
    SAVE_IMMUNIZATION,
    ADD_MEDICATION,
    SAVE_MEDICATION,
    REMOVE_MEDICATION,
    SAVE_ADMINISTERATCAMP,
    SAVE_EXCLUDED_ACTIVITIES,
    SAVE_MEDICAL_CONDITION,
    SAVE_MEDICAL_CONDITION_DETAILS,
    SAVE_SPECIAL_NEEDS,
    SAVE_ADMIN_MEDICATION,
    SIGN_AUTHORIZATION,
    // Step 4
    SAVE_WAIVER_INITIALS,
    AUTHORIZE_WAIVER_RELEASE,
    DEAUTHORIZE_WAIVER_RELEASE,
    // Errors,
    ADD_FORM_ERROR,
    CLEAR_FORM_ERRORS
};

export { IAction } from '../../../classes/action';


// WEBPACK FOOTER //
// ./app/camp-sign-up/redux/actions/actiontype.ts